import React, { useState } from "react";
import FriendList from "../../components/FriendsList/index.tsx";
import { UserPlus } from "lucide-react";
import Modal from "../../components/Modal/index.tsx";
import { AddFriendForm } from "../../components/AddFriendForm/index.tsx";

const Friends = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <section className="p-5 flex justify-center">
      <div className="container-site">
        <div className="flex flex-wrap gap-5 justify-between items-center mb-4">
          <div>
            <h3 className="heading-2">Connections</h3>
            <p className="sub-heading-2">Manage your financial connections</p>
          </div>
          <div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="btn-primary flex items-center gap-2 text-sm"
            >
              <UserPlus size={16} />
              Add Connection
            </button>
          </div>
        </div>
      <Modal
        isOpen={isModalOpen}
        title="Add Connection"
        onClose={() => {
          setIsModalOpen(false);
        }}
      >
        <AddFriendForm onAdd={() => setIsModalOpen(false)} />
      </Modal>
      <FriendList />
    </div>
    </section>
  );
};

export default Friends;
